<script lang="ts">
  import { useUserStore } from '@/stores/user'
  import { useAuthStore } from '@/stores/auth'

  export default {
    setup() {
      const authStore = useAuthStore()
      const userStore = useUserStore()
      userStore.setCurrentUser(null)
      authStore.logout()
    },
  }
</script>

<template>
  <div>
  </div>
</template>
